import { mapState as rootMapState } from 'pinia';
import { useUserStore } from '@/store';
import banner from '../../components/banner.vue';
import MediaContent from '../../components/media-content.vue';
import BannerButton from '../../components/banner-button.vue';
import { colorBlock } from '../defaultSpacing';
import signLog from '@/components/sign-log';
import util from '@/common/util';
export default {
    i18next: {
        ns: 'md-cta-single-column'
    },
    data: function() {
        return {
            sizeOption: {
                type: 'height',
                mobileType: 'height',
                height: 340,
                mobileHeight: 300
            },
            pictureOption: {
                src: '',
                mobileSrc: ''
            },
            maskOption: {
                showMask: true,
                maskColor: 'rgba(0,0,0,0.15)',
            },
            showOpacityLayer: true,
            title: '',
            subTitle: '',
            buttonAlign: 'center',
            buttons: [],
            verticalMargin: 50,
            HorizontalMargin: 80,
            contentColor: '',
            ...colorBlock,
            fullColumn: '',
            mobileNoMargin: '',
            showArrow: true,
            backgroundColor: '#ffffff',
            color: '#000',
            bgColor: '#212530'
        };
    },
    computed: {
        ...rootMapState(useUserStore, {
            user: store => store.user
        }),
        isMobile() {
            return this.platform.isMobile;
        },
        paddingTop() {
            return (
                (this.isMobile ? this.mobileTopSpacing : this.topSpacing) + 'px'
            );
        },
        marginBottom() {
            return (
                (this.isMobile ? this.mobileBtmSpacing : this.btmSpacing) + 'px'
            );
        },
        bannerStyle({ showOpacityLayer, verticalMargin }) {
            return showOpacityLayer
                ? {
                    paddingTop: verticalMargin + 'px',
                    paddingBottom: verticalMargin + 'px'
                }
                : {};
        }
    },
    methods: {
        calcRealSize() {
            const sizeOption = this.sizeOption || {};
            let type = sizeOption.type;
            let ratio = sizeOption.ratio;
            let height = sizeOption.height;
            if (this.isMobile) {
                type = sizeOption.mobileType;
                ratio = sizeOption.mobileRatio;
                height = sizeOption.mobileHeight;
            }
            const ele = this.$refs.banner && this.$refs.banner.$el;
            if (ele) {
                if (type === 'scale') {
                    ratio = (ele.offsetHeight / ele.offsetWidth) * 100;
                } else if (type === 'height') {
                    height = ele.offsetHeight;
                }
            }
            return {
                type: sizeOption.type,
                mobileType: sizeOption.mobileType,
                ratio: this.isMobile ? sizeOption.ratio : ratio,
                mobileRatio: this.isMobile ? ratio : sizeOption.mobileRatio,
                height: this.isMobile ? sizeOption.height : height,
                mobileHeight: this.isMobile ? height : sizeOption.mobileHeight
            };
        },
        showRegisterPop(action) {
            if (action && action.type === 'callback') {
                let role = action.registerRole || '';
                let tag = action.tag || '';
                if (!this.user) {
                    signLog.register({
                        role,
                        registerData: {
                            tag
                        }
                    });
                } else {
                    util.toast(
                        this.$t('md-cta-single-column.youAreAlreadyLogged'),
                        2000
                    );
                }
            }
        }
    },
    components: {
        banner,
        MediaContent,
        BannerButton
    }
};
